import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../utils/config';

function CallbackPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const handleGoogleCallback = async () => {
            const hashParams = new URLSearchParams(window.location.hash.substring(1));
            const accessToken = hashParams.get('access_token');

            if (accessToken) {
                try {
                    const dates = JSON.parse(localStorage.getItem('dates')) || [];

                    const response = await fetch(`${config.apiBaseUrl}/create-google-calendar-events`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ accessToken, dates }), // Ensure dates are passed correctly
                    });

                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const data = await response.json();
                    // console.log('Events created:', data);
                } catch (error) {
                    console.error('Error creating events:', error);
                }
            } else {
                console.error('Access token not found');
            }

            // Redirect to home or another page after handling the callback
            navigate('/');
        };

        handleGoogleCallback();
    }, [navigate]);

    return <div>Adding Dates...</div>;
}

export default CallbackPage;